export const selectContentEnableRecordingsTrimmingAnalytics = ({ flags }) =>
  flags?.contentEnableRecordingsTrimmingAnalytics || false;
